import { useMutation, useQuery, useQueryClient, UseQueryResult } from "@tanstack/react-query";
import { staffApi } from "./staffApi";
import { SkillLevel } from "../types/dtos";

export function useSkillLevels(includeInactive = false): UseQueryResult<SkillLevel[]> {
  return useQuery({
    queryKey: ["skill-levels", { includeInactive }],
    queryFn: async () => (await staffApi.get<SkillLevel[]>("/skill-levels", { params: { includeInactive } })).data,
  });
}

export function useCreateSkillLevel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { name: string; hourlyRate: number }) => staffApi.post("/skill-levels", input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["skill-levels"] }),
  });
}

export function useUpdateSkillLevel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: number; input: Partial<{ name: string; hourlyRate: number; active: boolean }> }) =>
      staffApi.patch(`/skill-levels/${id}`, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["skill-levels"] }),
  });
}

export function useDeleteSkillLevel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => staffApi.delete(`/skill-levels/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["skill-levels"] }),
  });
}
